/**
 * @since 2026-04-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import "./ButtonBlue.scss";

const ButtonBlue = ({
  label,
  children,
  onClick,
  disabled = false,
  alignment = "center",
  width,
  height,
  type = "button",
}) => {
  return (
    <div className={`buttonBlue ${alignment}`}>
      <button
        type={type}
        className="button-blue"
        onClick={onClick}
        disabled={disabled}
        style={{ width, height }}
      >
        {label ?? children}
      </button>
    </div>
  );
};

export default ButtonBlue;
